export default "__VITE_ASSET__65a1fb05__"